import { render, staticRenderFns } from "./ProductDefect.vue?vue&type=template&id=bef90daa&scoped=true"
import script from "./ProductDefect.vue?vue&type=script&lang=ts"
export * from "./ProductDefect.vue?vue&type=script&lang=ts"
import style0 from "./ProductDefect.vue?vue&type=style&index=0&id=bef90daa&prod&lang=scss&scoped=true"
import style1 from "./ProductDefect.vue?vue&type=style&index=1&id=bef90daa&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bef90daa",
  null
  
)

export default component.exports